// extracted by mini-css-extract-plugin
module.exports = {"bookingWrapper":"booking-view_bookingWrapper__2gsKL","bookingHeadline":"booking-view_bookingHeadline__2r0Rs","bookingTitle":"booking-view_bookingTitle__2YgWl"};